/**
 * Enhanced collapsible content animation
 */

class EnhancedDetailsAnimation extends HTMLElement {
  constructor() {
    super();
    this.detailsElements = this.querySelectorAll('details');

    this.detailsElements.forEach((details) => {
      details.addEventListener('click', (event) => {
        // Only trigger if it's the summary element
        if (event.target.closest('summary')) {
          event.preventDefault();
          
          // Toggle open state
          if (details.hasAttribute('open')) {
            this.close(details);
          } else {
            this.open(details);
          }
        }
      });
    });
  }
  
  open(details) {
    details.setAttribute('open', '');
    const content = details.querySelector('.image-with-collapsible__collapsible-content');
    
    // Get the actual height of the content
    content.style.maxHeight = 'none';
    const height = content.offsetHeight;
    content.style.maxHeight = '0px';
    
    // Trigger reflow
    content.offsetHeight;
    
    // Set the actual height
    content.style.maxHeight = height + 'px';
    
    // Reset after animation completes
    setTimeout(() => {
      content.style.maxHeight = ''; // Reset to CSS value
    }, 500);
  }
  
  close(details) {
    const content = details.querySelector('.image-with-collapsible__collapsible-content');
    const height = content.offsetHeight;
    
    // Set explicit height to enable animation
    content.style.maxHeight = height + 'px';
    
    // Trigger reflow
    content.offsetHeight;
    
    // Animate to zero
    content.style.maxHeight = '0px';
    
    // Complete closing after animation
    setTimeout(() => {
      details.removeAttribute('open');
      content.style.maxHeight = ''; // Reset to CSS value
    }, 500);
  }
}

customElements.define('enhanced-details-animation', EnhancedDetailsAnimation);
